














































































import { appModule } from "@/store/modules/app";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import KelasAutoComplete from "@/components/KelasAutoComplete.vue";
import DataBed from "@/services/DataBed";
import { storeBed } from "@/store/modules/bed";
import { userModule } from "@/store/modules/user";
@Component({
  components: {
    // UnitAutoComplete,
    KelasAutoComplete,
  },
})
export default class ModalRekapBed extends Vue {
  @Prop() readonly value!: boolean;
  search = "";
  get headers() {
    const head = [
      {
        text: "NO",
        value: "nomor",
        width: "5vh",
        align: "center",
        filterable: false,
      },
      {
        text: "Ruang Rawat",
        value: "unit",
        align: "left",
      },
      {
        text: "VIP-A",
        value: "vipa",
        width: "8vh",
        align: "center",
        filterable: false,
      },
      {
        text: "VIP-B",
        value: "vipb",
        width: "8vh",
        align: "center",
        filterable: false,
      },
      {
        text: "Kelas 1",
        value: "a1",
        width: "8vh",
        align: "center",
        filterable: false,
      },
      {
        text: "Kelas 2",
        value: "a2",
        width: "8vh",
        align: "center",
        filterable: false,
      },
      {
        text: "Kelas 3",
        value: "a3",
        width: "8vh",
        align: "center",
        filterable: false,
      },
      {
        text: "Kelas Khusus",
        value: "ak",
        width: "12vh",
        align: "center",
        filterable: false,
      },
      {
        text: "Isolasi",
        value: "ai",
        width: "8vh",
        align: "center",
        filterable: false,
      },
    ];
    return head;
  }

  get rekapBed() {
    return storeBed.rekapBed;
  }

  close() {
    this.show = false;
  }

  get show() {
    return this.value;
  }

  set show(value) {
    this.$emit("input", value);
  }
}
